<template>
  <div>
    <PersonalSchedule class="mt-2" :type="'page'"/>
  </div>
</template>

<script>
import PersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/PersonalSchedule.vue";
import { mapGetters } from "vuex";

export default {
  name: "Schedule",
  components: {
    PersonalSchedule,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>